import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-9', 'Number9', [["path",{"d":"M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0"}],["path",{"d":"M8 16a4 4 0 1 0 8 0v-8"}]]);